import { OnInit, Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Company } from 'src/app/models/data/company';
import { ApiService, QueryParam } from 'src/app/services/api.services';
import { NavigationHistoryService } from 'src/app/services/navigation-history.service';
import { CompanyEntityRelationshipTableComponent } from '../../../../components/company-entity-relationship-table/company-entity-relationship-table.component';

@Component({
	selector: 'app-company-relationships',
	templateUrl: './company-relationships.component.html',
	styleUrls: [
		'./company-relationships.component.css',
		'../../../common/main.scss',
	],
	imports: [CompanyEntityRelationshipTableComponent],
})
export class CompanyRelationshipsComponent {
	@Input() company?: Company;

	readonly companyId: string;
	readonly dataRequest = (queryParams: QueryParam[]) =>
		this.apiService.getCompanyRelationshipsByCompanyId(
			this.companyId,
			queryParams
		);

	constructor(
		private route: ActivatedRoute,
		private apiService: ApiService
	) {
		this.companyId = this.route.snapshot.params.id;
	}
}
